export default {
  customLayout: 'coursedog', // NOTE: We want all new catalogs to have coursedog theme by default
}

